export const FixedRight = 'right' as const
export const FixedLeft = 'left' as const
